import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { Card, RaisedButton } from 'material-ui';

const InternalExtraActions = props => {
  const {
    firstName,
    postCompName,
    goToPostCompProfile,
  } = props;

  return (
    <Card style={{ width: '62%', margin: '10px 0 0 23%', padding: '1% 2%', color: 'rgba(0, 0, 0, 0.54)' }}>
      <div style={{ minHeight: '35px', overflow: 'hidden' }}>
        <div className="hide-float-center" style={{ float: 'left', marginTop: '5px', fontSize: '16px', display: 'inline-block' }}>
          Welcome back{firstName ? `, ${firstName}` : ''}!
        </div>
        <div className="hide-float-center" style={{ float: 'right', display: 'inline-block' }}>
          <RaisedButton label="View Company Details" secondary onTouchTap={goToPostCompProfile} />
        </div>
      </div>
    </Card>
  );
};

InternalExtraActions.propTypes = {
  firstName: PropTypes.string,
  postCompName: PropTypes.string,
  goToPostCompProfile: PropTypes.func,
};

const mapStateToProps = ({ user }) => ({
  firstName: user.getIn(['user', 'firstName']),
});

export default connect(mapStateToProps)(InternalExtraActions);



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/postPage/internalExtraAction.jsx